import styled from 'styled-components'

export const ChangeWrapper = styled.div`
	font-size: var(--fs-xxs);
	color: var(--btn-color);
	font-weight: var(--fw-sm);
	cursor: pointer;
`

export const OTPText = styled.div`
	font-size: var(--fs-xxs);
	letter-spacing: 0.9px;
	color: var(--text-info-color);
`
